import { render, staticRenderFns } from "./CorporationDetails.vue?vue&type=template&id=9a61054a&"
import script from "./CorporationDetails.vue?vue&type=script&lang=js&"
export * from "./CorporationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports